(function () {

  const SMALL_FEE = 43273980772465;

  const feeVariants = {
    3: 43273980805233,
    4: 43273980838001,
    5: 43273980870769,
    6: 43273980903537,
    7: 43273980936305,
    8: 43273980969073,
    9: 43273981001841,
    10: 43273981034609,
    11: 43273981067377,
    12: 43273981100145,
    13: 43273981132913,
    14: 43273981165681,
    15: 43273981198449,
    16: 43273981231217,
    17: 43273981263985,
    18: 43273981296753,
    19: 43273981329521,
    20: 43273981362289,
    21: 43273981395057,
    22: 43273981427825,
    23: 43273981460593,
    24: 43293084156017,
    25: 43293084254321,
    26: 43293084680305,
    27: 43293084713073,
    28: 43293084745841,
    29: 43293084778609,
    30: 43293084909681
  };

  const ALL_FEES = [
    SMALL_FEE,
    ...Object.values(feeVariants)
  ];

  let busy = false;

  async function getCart() {
    return fetch('/cart.js?t=' + Date.now()).then(r => r.json());
  }

  function getFeeInfo(subtotal) {

    if (subtotal <= 99) {
      return {
        fee: 2,
        variant: SMALL_FEE
      };
    }

    let fee = Math.ceil(subtotal * 0.03);

    if (fee < 3) fee = 3;
    if (fee > 30) fee = 30;

    return {
      fee: fee,
      variant: feeVariants[fee]
    };
  }

  async function syncProtection() {

    if (busy) return;

    const cart = await getCart();

    let subtotal = 0;
    let protectionItem = null;

    cart.items.forEach(item => {

      if (ALL_FEES.includes(item.variant_id)) {
        protectionItem = item;
      } else {
        subtotal += item.final_line_price;
      }

    });

    subtotal = subtotal / 100;

    if (subtotal === 0) {

      const feeLine = cart.items.findIndex(
        item => ALL_FEES.includes(item.variant_id)
      );

      if (feeLine > -1) {

        busy = true;

        try {

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              line: feeLine + 1,
              quantity: 0
            })
            
          });

        } catch (e) {
          console.log(e);
        }

        busy = false;
      }

      return;
    }

    const feeInfo = getFeeInfo(subtotal);
    if (!protectionItem) {

  busy = true;

  try {

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: feeInfo.variant,
        quantity: 1
      })
    });

  } catch (e) {
    console.log(e);
  }

  busy = false;

  setTimeout(syncProtection, 500);

  return;
}
    
document
  .querySelectorAll('.shipping-protection-toggle')
  .forEach(el => {
    el.checked = !!protectionItem;
    el.dataset.variant = feeInfo.variant;
  });
  
    document
      .querySelectorAll('.shipping-protection-price')
      .forEach(el => {
        el.innerHTML = '$' + feeInfo.fee.toFixed(2);
      });

    if (
      protectionItem &&
      protectionItem.variant_id !== feeInfo.variant
    ) {

      busy = true;

      try {

        const feeLine = cart.items.findIndex(
          item => ALL_FEES.includes(item.variant_id)
        );

        if (feeLine > -1) {

          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              line: feeLine + 1,
              quantity: 0
            })
          });

        }

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: feeInfo.variant,
            quantity: 1
          })
        });

      } catch (e) {
        console.log(e);
      }

      busy = false;

      setTimeout(syncProtection, 500);
    }
  }

  document.addEventListener('change', async function (e) {

    if (
      !e.target.classList.contains(
        'shipping-protection-toggle'
      )
    ) return;

    if (busy) return;

    busy = true;

    try {

      const cart = await getCart();

      const feeItem = cart.items.find(item =>
        ALL_FEES.includes(item.variant_id)
      );

      const variantId =
        Number(e.target.dataset.variant);

      if (e.target.checked) {

        if (!feeItem) {

          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

        }

      } else {

        if (feeItem) {

          const feeLine = cart.items.findIndex(
            item => ALL_FEES.includes(item.variant_id)
          );

          if (feeLine > -1) {

            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                line: feeLine + 1,
                quantity: 0
              })
            });

          }

        }

      }

    } catch (err) {
      console.log(err);
    }

    busy = false;

    setTimeout(syncProtection, 500);

  });

 document.addEventListener( 'DOMContentLoaded',
     syncProtection );
 document.addEventListener( 'cart:refresh',
     function () { setTimeout(syncProtection, 500);

      }
     );
      setInterval(syncProtection, 5000); 
    })();